module.exports = __webpack_public_path__ + "img/angry_ios_802.png";